import { render, staticRenderFns } from "./mNoticeDetails.vue?vue&type=template&id=3cfc4d94&scoped=true"
import script from "./mNoticeDetails.vue?vue&type=script&lang=js"
export * from "./mNoticeDetails.vue?vue&type=script&lang=js"
import style0 from "./mNoticeDetails.vue?vue&type=style&index=0&id=3cfc4d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfc4d94",
  null
  
)

export default component.exports